export const MARCAS = [
  { id: 'extk', label: 'EXTK' },
  { id: 'onda', label: 'ONDA TELECOM' },
  { id: 'vision', label: 'VISION TELECOM' }
];

export const MARCA_IDS = MARCAS.map((m) => m.id);
export const MARCAS_PERMITIDAS_DEFAULT = [...MARCA_IDS];

export const marcaExigeNumeroOrdem = (marca) => ['onda', 'vision'].includes(marca);
export const marcaAutoAguardandoInstalacao = (marca) => ['onda', 'vision'].includes(marca);
export const marcaAutoValidacaoOk = (marca) => marca === 'extk';

export const formatMarcaLabel = (marca) => {
  const found = MARCAS.find((m) => m.id === marca);
  return found ? found.label : '-';
};

export const isMarcaValida = (marca) => MARCA_IDS.includes(marca);

export const normalizeMarcasArray = (value) => {
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  const result = [];
  for (const item of value) {
    const id = String(item || '').trim();
    if (isMarcaValida(id) && !seen.has(id)) {
      seen.add(id);
      result.push(id);
    }
  }
  return result;
};

export const parseMarcasArray = (raw) => {
  if (Array.isArray(raw)) return normalizeMarcasArray(raw);
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return normalizeMarcasArray(parsed);
    } catch {
      return [];
    }
  }
  return [];
};

const papTipoToMarcas = (papTipo) => {
  switch (papTipo) {
    case 'extk': return ['extk'];
    case 'onda': return ['onda'];
    case 'ambos': return ['extk', 'onda'];
    default: return [];
  }
};

const marcaPermitidaToMarcas = (marcaPermitida) => {
  switch (marcaPermitida) {
    case 'extk': return ['extk'];
    case 'onda': return ['onda'];
    case 'ambos':
    default:
      return ['extk', 'onda'];
  }
};

export const resolvePapMarcas = (usuario) => {
  const fromArray = parseMarcasArray(usuario?.pap_marcas);
  if (fromArray.length > 0 || (usuario?.pap_marcas != null && Array.isArray(usuario.pap_marcas))) {
    return fromArray;
  }
  if (usuario?.pap_tipo) {
    return papTipoToMarcas(usuario.pap_tipo);
  }
  return usuario?.possui_pap ? ['extk'] : [];
};

export const resolveMarcasPermitidas = (usuario) => {
  const fromArray = parseMarcasArray(usuario?.marcas_permitidas);
  if (fromArray.length > 0 || (usuario?.marcas_permitidas != null && Array.isArray(usuario.marcas_permitidas))) {
    return fromArray;
  }
  if (usuario?.marca_permitida) {
    return marcaPermitidaToMarcas(usuario.marca_permitida);
  }
  return ['extk', 'onda'];
};

export const vendedorTemPapDaMarca = (usuario, marca) => {
  if (!marca) return false;
  return resolvePapMarcas(usuario).includes(marca);
};

export const vendedorPodeVenderMarca = (usuario, marca) => {
  if (!marca) return true;
  return resolveMarcasPermitidas(usuario).includes(marca);
};

export const formatMarcasPermitidasErro = (marcas) => {
  const labels = normalizeMarcasArray(marcas).map(formatMarcaLabel);
  if (labels.length === 0) return 'nenhuma marca';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} ou ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')} ou ${labels[labels.length - 1]}`;
};

export const toggleMarcaInArray = (arr, marcaId, checked) => {
  const current = normalizeMarcasArray(arr);
  if (checked) {
    return current.includes(marcaId) ? current : [...current, marcaId];
  }
  return current.filter((id) => id !== marcaId);
};
